<template>
  <div class="invoice">
    <div class="page-title">
      <custom-breadcrumb :suffix="`Invoice NO. ${invoice.invoiceCode}`"/>
<!--       <div>-->
<!--        <p>-->
<!--            <span class="gery-color" @click="toOrders()">Orders >-->
<!--            </span>-->
<!--            <span class="gery-color" v-if="this.$route.query.orderType" @click="detail()">Order Details></span>-->
<!--            <span class="invoice-title" >Invoice</span>-->
<!--            <span class="order-title">Invoice NO. {{invoice.invoiceCode}}</span>-->
<!--        </p>-->
<!--       </div>-->
       <div>
         <div class="invoice-export-created" v-if="invoice['isExporting']" title="Invoice creation after completion, the button is displayed as “Invoice”, and the invoice can be exported.">
           Invoice is being created
         </div>
         <el-button class="invoice-export" @click="exportInvoice" v-else>Export Invoice</el-button>
       </div>
    </div>
    <div class="invoice-header">
      <!-- <div class="invoice-header-content">
        <div @click="openAddress('billAddressid')">Bill To<span class="memo-address"><img src="@/assets/img/memo.png" alt=""></span></div>
          <div v-if="invoice['billAddress']!==null">
            {{invoice['billAddress']['name']}}&nbsp;&nbsp;{{invoice['billAddress']['lastname']}}<br/>
            {{invoice['billAddress']['address']}}<br/>
            {{invoice['billAddress']['city']}}, {{invoice['billAddress']['province']}}, {{invoice['billAddress']['countryName']}}&nbsp;&nbsp;{{invoice['billAddress']['postCode']}}<br/>
            {{invoice['billAddress']['areaCode']}}-{{invoice['billAddress']['phone']}}<br/>
          </div>
      </div>

      <div class="invoice-header-content header-border">
        <div @click="openAddress('shipAddressid')">Ship To<span class="memo-address"><img src="@/assets/img/memo.png" alt=""></span></div>
        <div v-if="invoice['shipAddress']!==null">
          {{invoice['shipAddress']['name']}}&nbsp;&nbsp;{{invoice['shipAddress']['lastname']}}<br/>
          {{invoice['shipAddress']['address']}}<br/>
          {{invoice['shipAddress']['city']}}, {{invoice['shipAddress']['province']}}, {{invoice['shipAddress']['countryName']}}&nbsp;&nbsp;{{invoice['shipAddress']['postCode']}}<br/>
          {{invoice['shipAddress']['areaCode']}}-{{invoice['shipAddress']['phone']}}<br/>
            </div>
      </div> -->
      <div class="invoice-header-content heder-right">
        <div>Order #{{invoice.orderId}}</div>
        <div>{{invoice.orderDate}}</div>
      </div>

    </div>

    <div class="invoice-account-table">
      <el-table :data="accountTable" style="width: 100%">
         <el-table-column
          label="Account #"
          >
           <template slot-scope="scope">
              <el-input v-model="scope.row.account" @change="accountChange('account')"></el-input>
          </template>
      </el-table-column>
      <el-table-column
          prop="brandName"
          label="Brand"
          >
      </el-table-column>
      <el-table-column
          prop="date"
          label="Date"
          >
      </el-table-column>
      <el-table-column
          label="Salesperson"
          >
          <template slot-scope="scope">
              <el-input v-model="scope.row.salesperson" @change="accountChange('salesperson')"></el-input>
          </template>
      </el-table-column>
      <el-table-column
          label="Terms"
          >
          <template slot-scope="scope">
              <el-input v-model="scope.row.terms" @change="accountChange('terms')"></el-input>
          </template>
      </el-table-column>
      <el-table-column
          label="Ship Via"
          >
          <template slot-scope="scope">
              <el-input v-model="scope.row.shipVia" @change="accountChange('shipVia')"></el-input>
          </template>
      </el-table-column>
      </el-table>
    </div>
    <div class="invoice-description-table">
      <el-table :data="descriptionTable" style="width: 100%">
         <el-table-column
          label="Description"
          min-width="300"
          >
           <template slot-scope="scope">
              <div class="desc">
                <div class="desc-img"><img :src="scope.row.skuImg" alt=""></div>
                <div class="desc-text">
                  <div>{{scope.row.skuName}}</div>
                  <div>{{scope.row.skuParams}}</div>
                </div>
              </div>
          </template>
      </el-table-column>
      <el-table-column
          prop="brandName"
          label="Brand"
          >
      </el-table-column>
      <el-table-column
          label="OrderPlaced"
          >
          <template slot-scope="scope">
                  {{scope.row.num}}
          </template>
      </el-table-column>
      <el-table-column
          prop="shipped"
          label="Shipped"
          >
        <template slot-scope="scope">
          <el-input v-model="scope.row.shipped" @blur="(event)=>boChang(event,scope.$index,1)"
                    oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')} if(value<=0){value=0}"></el-input>
        </template>
      </el-table-column>
      <el-table-column
          label="B/O"
          >
          <template slot-scope="scope">
              <el-input v-model="scope.row.backOrder" @blur="(event)=>boChang(event,scope.$index,2)"
                     oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')} if(value<=0){value=0}"></el-input>
          </template>
      </el-table-column>
      <el-table-column
          prop="unitPriceBeforeDiscount"
          label="ListPrice"
          >
      </el-table-column>
      <el-table-column
          prop="unitPrice"
          label="Disc. Price"
          >
      </el-table-column>
      <el-table-column
          prop="commodityAmount"
          label="Total"
          >
      </el-table-column>
      </el-table>
    </div>
    <div class="invoice-footer">
      <div>
        <div class="invoice-footer-payment">Payment method : <span>{{invoice['payMethod']}}</span> </div>
        <div class="invoice-footer-memo" @click='openMemo(invoice.memo)'>
          <span class="invoice-footer-memo-title">Memo</span>
          <span><img src="@/assets/img/memo.png" alt=""></span>
          <span class="invoice-footer-memo-text">
            {{invoice.memo}}
          </span>
        </div>
      </div>
      <div class="invoice-footer-price">
        <div class="invoice-footer-price-title">
          <div>Total quantity</div>
          <div>Total list pirce</div>
          <div class="textColor-y">Product discount</div>
          <div class="textColor-y">Supplier order discount</div>
          <div>Shipping</div>
          <div class="textColor-b">Total Amount</div>
        </div>
        <div class="invoice-footer-price-num">
          <div>{{invoice.goodsNum}}</div>
          <div>${{invoice.totalPriceBefore}}</div>
          <div class="textColor-y">-${{invoice.productDiscounted}}</div>
          <div class="textColor-y">-${{invoice.orderDiscounted}}</div>
          <div>${{invoice.totalFreight}}</div>
          <div class="textColor-r">${{invoice.payAmount}}</div>
        </div>
      </div>
    </div>
     <div>
      <Address ref="address" :addressMessage="addressMessage"  />
    </div>
    <div>
      <edit-memo :message="memoMessage" ref="memo"></edit-memo>
    </div>
  </div>
</template>

<script>
import { getAction, putAction, downloadFile,downloadStaticFile } from '@/api/manage.js'
import Address from '@/pages/components/address.vue'
import editMemo from '@/pages/components/edit-memo.vue'
import CustomBreadcrumb from '../components/custom-breadcrumb'
export default {
  name: 'invoice',
  components: {
    Address,
    editMemo,
    CustomBreadcrumb
  },
  data() {
    return {
      memoMessage: {},
      orderId: '',
      invoice: {},
      addressMessage: {},
      accountList: {
        invoiceId: '',
        account: '',
        date: '',
        salesperson: '',
        terms: '',
        shipVia: '',
        memo: '',
        billAddressid: '',
        shipAddressid: ''
      },
      accountTable: [],
      descriptionTable: []
    }
  },
  created() {
    this.orderId = this.$route.query.orderId
    this.getOrderInvoice()
  },
  methods: {
    openAddress(type) {
      this.addressMessage = {
        addressId: type === 'shipAddressid' ? this.invoice.shipAddressid : this.invoice.billAddressid,
        userId: this.invoice.userId,
        type: 'invoice',
        idType: type
      }
      this.$refs.address.dialogVisible = true
    },
    getOrderInvoice() {
      getAction(`/sp/suppliers/invoice/${this.orderId}`).then((res) => {
        this.invoice = res.result
        this.descriptionTable = res.result.detailList
        this.accountObject()
      })
    },
    accountObject() {
      this.accountTable = []
      let keys = Object.keys(this.accountList)
      keys.map((e, i) => {
        this.accountList[e] = this.invoice[e]
      })
      this.accountTable.push(this.accountList)
    },
    accountChange(type) {
      this.submit()
    },
    editInvoice(type, value) {
      console.log(type, value)
      this.accountTable[0][type] = value
      console.log(this.accountTable)
      this.submit()
    },
    boChang(event, index,type) {
      let value = event.target.value
      if (value) {
        let obj = this.descriptionTable[index];
        if (value > obj['num']) {
          value = obj['num']
        }


        let shipped = 0
        let backOrder = 0
        if (type == 1) {
          shipped = value;
          backOrder = obj['num'] - Number(shipped)
        } else {
          backOrder = value
          shipped = obj['num'] - Number(backOrder)
        }

        this.$set(this.descriptionTable[index], 'backOrder', backOrder)
        this.$set(this.descriptionTable[index], 'shipped', shipped)
        this.$set(this.descriptionTable[index], 'commodityAmount', (shipped*obj['unitPrice']).toFixed(2))

        this.invoice['isExporting'] = false

        putAction('/sp/suppliers/invoice/detail?', {
          orderDetailId: obj['uid'],
          backOrder: backOrder,
          shipped: shipped,
        }).then((res) => {
          if (!res.success) {
            this.$message.error(res.message)
          }
          this.getOrderInvoice()
        })

      }


    },
    submit() {
      this.accountTable[0]['invoiceId'] = this.invoice['uid']
      putAction('/sp/suppliers/invoice/head?', this.accountTable[0]).then((res) => {
        if (!res.success) {
          this.$message.error(res.message)
        }
      })
    },
    toOrders() {
      this.$router.push({ path: 'Order' })
    },
    detail() {
      let order = this.$route.query.orderId
      this.$router.push({path: 'OrderDetail', query: {orderId: order}})
    },
    openMemo(val) {
      this.memoMessage = {
        memo: val,
        type: 'invoice'
      }
      this.$refs.memo.dialogVisible = true
    },
    exportInvoice() {
     // downloadFile(`/sp/suppliers/invoice/export/${this.$route.query.orderId}`, `invoice_${this.invoice['invoiceCode']}_${Date.now()}.pdf`, '')
      getAction(`/sp/suppliers/invoice/export/${this.orderId}`).then((res) => {
        if(res['success']){
          downloadStaticFile(res['result'])
        }
      })


    }
  }
}
</script>

<style scoped lang="less">
.page-title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
}
.gery_color {
  color: #8f8f8f;
  cursor: pointer;
}
.invoice-title{
  font-size: 14px;
  font-weight: 500;
  color: #262B2F;
}
.order-title{
  font-size: 14px;
  font-weight: 500;
  color: #262B2F;
  padding-left: 33px;
}
.invoice-export{
  width: 159px;
  height: 40px;
  background: #000000;
  border-radius: 5px;
  color: #ffffff;
}
.invoice-export-created{
  background: #8E8E8E;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  color: #ffffff;
  padding: 0 5px;
  position: relative;
}
.invoice-header{
  width: 100%;
  /* height: 94px; */
  padding: 14px 20px 10px 50px;
  box-sizing: border-box;
  border: 1px solid #E1E1E1;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-border{
  padding: 0 30px 0 30px;
  border-left: 1px solid #E1E1E1;
  border-right: 1px solid #E1E1E1;
}
.heder-right{
  padding-left: 10px;
  text-align: right;
}
.invoice-account-table{
  margin-top: 20px;
  border: 1px solid #E1E1E1;
}
.invoice-description-table{
  border: 1px solid #E1E1E1;
  margin-top: 20px;
}
.invoice-footer{
  padding-top: 32px;
  display: flex;
  justify-content: space-between;
  .invoice-footer-payment{
    font-size: 16px;
    font-weight: 800;
    color: #262B2F;
    span{
      font-size: 16px;
      font-weight: 400;
      color: #262B2F;
    }
  }
  .invoice-footer-memo{
    padding-top:21px ;
  }
  .invoice-footer-price{
    max-width: 305px;
    display: flex;
    justify-content: space-between;
    text-align: right;
    .invoice-footer-price-title{
      padding-right: 50px;
      line-height: 30px;
    }
    .invoice-footer-price-num{
      line-height: 30px;
    }
  }
}
.invoice-footer-memo-title{
  padding-right: 15px;
}
.invoice-footer-memo-text{
  padding-left: 17px;
}
.memo-address{
  padding-left: 15px;
  cursor: pointer;
}
.desc{
  display: flex;
  .desc-img{
    width: 120px;
    height: 120px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .desc-text{
    padding-left: 20px;
    width: 300px;
    font-size: 14px;
    font-family: Avenir;
    font-weight: 800;
    color: #262B2F;
    div:nth-child(2){
      padding-top: 20px;
    }
  }
}
.textColor-y{
  font-family: Graphik;
  font-weight: 400;
  line-height: 30px;
  color: #C3824B;
  opacity: 1;
}
.textColor-b{
font-size: 16px;
font-weight: 500;
line-height: 30px;
color: #262B2F;
}
.textColor-r{
  font-size: 16px;
  font-weight: 500;
  line-height: 30px;
  color: #FB541C;
}
.invoice-footer-memo{
  max-width: 657px;
}
.invoice-footer{
  padding-right: 10px;
}
.invoice-header-content{
  width: 33%;
}
.gery-color{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/invoice.vue